import '../css/app.css';

import { createInertiaApp } from '@inertiajs/vue3';
import Vue3TouchEvents, { type Vue3TouchEventsOptions } from 'vue3-touch-events';

import Aura from '@primeuix/themes/aura';
import axios from 'axios';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import 'primeicons/primeicons.css';
import Column from 'primevue/column';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import DataTable from 'primevue/datatable';

import Tooltip from 'primevue/tooltip';
import { createApp, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';

import { initStores } from '@/stores/initStores';

// My custom Polling Service
import { createPollingManager } from './services/pollingService';
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $pollingManager: ReturnType<typeof import('./services/pollingService').createPollingManager>;
    }
}

axios.defaults.withCredentials = true;

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const pages = import.meta.glob('./pages/**/*.vue');

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => {
        const normalizedName = name.replace(/\\/g, '/');

        return resolvePageComponent(`./pages/${normalizedName}.vue`, pages).then((module: any) => module.default ?? module);
    },

    setup({ el, App, props, plugin }) {
        const vueApp = createApp({ render: () => h(App, props) });

        const stores = initStores();
        vueApp.provide('appStores', stores);

        vueApp.use(plugin);

        vueApp.use(ZiggyVue, props.initialPage.props.ziggy as any);

        vueApp.use(PrimeVue, {
            theme: {
                preset: Aura,
            },
        });
        vueApp.use(ConfirmationService);

        vueApp.use<Vue3TouchEventsOptions>(Vue3TouchEvents, {
            disableClick: false,
            swipeTolerance: 50,
        });
        vueApp.component('DataTable', DataTable);
        vueApp.component('Column', Column);

        vueApp.directive('tooltip', Tooltip);

        const pollingManager = createPollingManager();
        pollingManager.start();
        vueApp.config.globalProperties.$pollingManager = pollingManager;

        vueApp.mount(el);

        return vueApp;
    },
    progress: {
        color: '#4B5563',
    },
});
